import EmailInput from './EmailInput/EmailInput';
import HookInput from './HookInput';
import Input from './Input';
import PasswordInput, { PASSWORD_RULES } from './PasswordInput/PasswordInput';
import PhoneInput from './PhoneInput/PhoneInput';
export type { InputProps, HookInputProps, PasswordInputProps } from './Input.types';

export default Input;
export { HookInput, EmailInput, PasswordInput, PhoneInput, PASSWORD_RULES };
